import { render, staticRenderFns } from "./StoreAppealList.vue?vue&type=template&id=d6164b5a&scoped=true&lang=pug"
import script from "./StoreAppealList.vue?vue&type=script&lang=js"
export * from "./StoreAppealList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6164b5a",
  null
  
)

export default component.exports